module.exports = __webpack_public_path__ + "static/media/ws.0457de46.pdf";